/*
* formatMoney: given an integer, returns a string separated
* with commas
*/
export default function formatMoney(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
